import { getContent } from '../store/ContentStore';

export const loadFooterConstantsEn = () => {
    const content = getContent("footer.", "en");

    if (!content || !content.en) {
        return {};
    }

    const english = content.en;

    return {
        text: english['footer.text'] || '',
        terms: english['footer.terms'] || ''
    };
};

export const loadFooterConstantsRo = () => {
    const contentRo = getContent("footer.", "ro");
    const contentEn = getContent("footer.", "en");

    if (!contentRo || !contentRo.ro || !contentEn || !contentEn.en) {
        return {};
    }

    const ro = contentRo.ro;
    const en = contentEn.en;

    return {
        text: ro['footer.text'] || en['footer.text'] || '',
        terms: ro['footer.terms'] || en['footer.terms'] || ''
    };
};
